import Box from "@mui/material/Box";
import type {SxProps, Theme} from "@mui/material/styles";
import type {DetailedHTMLProps, HTMLAttributes} from "react";

/**
 * The header slot for the collapsed Subspace Communicator card. The card
 * bundle (injected by the preview proxy) mounts the card into the first
 * connected `<subspace-dock>` when the Subspace UI is on. The slot is
 * empty and takes no space on every other page.
 */

declare global {
    namespace JSX {
        interface IntrinsicElements {
            "subspace-dock": DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>;
        }
    }
}

const dockSx: SxProps<Theme> = {
    display: "inline-flex",
    alignItems: "center",
    minWidth: 0,
    mr: 1,
    "&:empty": {display: "none"},
};

export default function SubspaceDock() {
    return <Box component="subspace-dock" sx={dockSx} data-cy="subspaceDock" />;
}
